import { ApolloClient, gql } from '@apollo/client/core';
import { Query } from '../../generated/graphql';
import * as Attachment from './Attachment';

const CREATE_ATTACHMENT_MUTATION = gql`
  mutation SaveAttachmentMeta($attachment: CreateAttachmentInput!) {
    createAttachment(input: $attachment) {
      attachment {
        id
        accountId
        checksum
        derivedFromId
        mime
        name
        size
        status
      }
      clientMutationId
      errors
    }
  }
`;

type PendingAttachmentInput = {
  name: string;
  size: number;
  checksum?: string;
  mime: string;
};

export const savePendingAttachmentMeta = async (client: ApolloClient<Query>, attachment: PendingAttachmentInput) => {
  const { data } = await client.mutate({
    mutation: CREATE_ATTACHMENT_MUTATION,
    variables: {
      attachment: {
        attachment,
      },
    },
  });

  if (data.createAttachment.attachment) {
    return Attachment.fromGql(data.createAttachment.attachment);
  }
};
